'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Hand';

var EntypoHand = function EntypoHand(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M17.924,17.315c-0.057,0.174-0.193,0.367-0.416,0.432c-0.161,0.047-5.488,1.59-5.652,1.633c-0.469,0.125-0.795,0.033-1.009-0.156c-0.326-0.287-4.093-2.85-8.845-3.092c-0.508-0.025-0.259-1.951,1.193-1.951c0.995,0,3.904,0.723,4.255,0.371c0.271-0.272,0.394-1.879-0.737-4.683l0,0L4.438,4.232C4.222,3.697,4.482,3.089,5.016,2.873c0.535-0.216,1.145,0.043,1.359,0.578c0,0,1.791,4.438,1.986,4.919c0.193,0.48,0.431,0.662,0.69,0.562C9.282,8.844,9.33,8.69,9.19,8.223L7.144,2.195C6.958,1.649,7.25,1.057,7.796,0.871c0.547-0.187,1.141,0.106,1.325,0.652l1.946,5.732c0.172,0.504,0.354,0.768,0.642,0.646c0.173-0.073,0.161-0.338,0.115-0.569l-1.366-5.471c-0.14-0.561,0.201-1.127,0.761-1.267c0.56-0.139,1.125,0.2,1.266,0.761l1.26,5.042c0.184,0.741,0.353,1.008,0.646,0.935c0.299-0.073,0.285-0.319,0.244-0.522c-0.095-0.475-0.872-4.328-0.872-4.328c-0.103-0.515,0.23-1.015,0.744-1.118c0.513-0.103,1.014,0.23,1.116,0.743l0.948,4.711l0.001,0.001c0,0,0,0,0,0.001l0.568,2.825c0.124,0.533,0.266,1.035,0.45,1.527C18.675,14.061,18.109,16.736,17.924,17.315z' })
    );
};

exports.default = EntypoHand;
module.exports = exports['default'];